import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
export default (function (context, inject) {
  var plugin = {
    /**
     * Check if the location has the required gate
     * @param {string} model - Name of the gate
     */
    get: function get(gate) {
      var active = context.$auth.active;
      var gates = this.list;

      // Check if there is an active user and gates are available
      if (!active || !gates) {
        return false;
      }

      // Check if the user has the required model
      return gates.includes(gate);
    },
    /**
     * Check if the location has all the required gates in array
     * @param {array} gates - A list of gates
     * @returns boolean
     */
    all: function all(gates) {
      var _this = this;
      return gates.every(function (gate) {
        return _this.get(gate);
      });
    },
    /**
     * Check if the location has any of the required gates in array
     * @param {array} gates - A list of gates
     * @returns boolean
     */
    any: function any(gates) {
      var _this2 = this;
      return gates.some(function (gate) {
        return _this2.get(gate);
      });
    },
    /**
     * Return the required gates for a given path
     * @param {string} path - A path to check
     * @returns boolean
     */
    route: function route(path) {
      if (!path) {
        return false;
      }
      var resolved = context.app.router.resolve(path);
      var gates = resolved && resolved.route ? resolved.route.meta.gates : null;
      return gates;
    },
    /**
     * Check if location has the required gates for given path
     * @param {string} path - A path to check
     * @returns boolean
     */
    access: function access(path) {
      if (!path) {
        return false;
      }
      var resolved = context.app.router.resolve(path);
      var gates = resolved && resolved.route ? resolved.route.meta.gates : null;
      if (!gates) {
        return true;
      }
      return this.all(gates);
    },
    /**
     * Get a list of the locations gates
     */
    get list() {
      var info = context.store.getters['auth/info'];
      return info.gates;
    }
  };
  inject('gates', plugin);
});